import { Alert, Button, Card, Form, Input, Select } from 'antd'
import * as React from 'react'
import { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import filterListApi from 'src/component/app/filterList/FilterListApi'
import { FilterListBean } from '../../../api/api'
import { formDataLoader, FormDataType } from '../../../util/FormDataLoader'

const FormItem = Form.Item
const Option = Select.Option
const TextArea = Input.TextArea

const formInfoItems: FormDataType[] = [
    FormDataType.Countries
]

const FilterListEdit = () => {

    const [info, setInfo] = useState({
        countries: [],
    })
    const navigateTo = useNavigate()
    const { id } = useParams<{ id: string }>()
    const [error, setError] = useState(undefined)
    const [form] = Form.useForm()

    const handleSubmit = async () => {
        const values = await form.validateFields()
        try {
            await filterListApi.edit(id, values)
            navigateTo('/filter-list')
        } catch (e) {
            setError(e.error)
        }
    }

    const loadData = async () => {
        try {
            const response: any = await filterListApi.view(id)
            form.setFieldsValue(response.data)

            const formInfo = await formDataLoader(...formInfoItems)
            setInfo(formInfo as any)
        } catch (e) {
            setError(e.error)
        }
    }

    useEffect(() => {
        loadData()
    }, [id])

    return <Form
        style={{
            maxWidth: '1000px', margin: '0 auto'
        }}
        onFinish={handleSubmit}
        form={form}
        labelCol={{ span: 5 }}
        wrapperCol={{ span: 16 }}
    >
        {error && <Alert message={error} type="error" />}
        <Card title="Filter List" size="small" className="form-card">
            <FormItem
                required
                name="name"
                label="Name"
            >
                <Input placeholder="Name"/>
            </FormItem>
            <FormItem
                required
                name="filterType"
                label="Filter list type"
            >
                <Select placeholder="Select filter list type">
                    {Object.values(FilterListBean.FilterTypeEnum).map(type => <Option key={type} value={type}>{type}</Option>)}
                </Select>
            </FormItem>
            <FormItem
                required
                name="filterMode"
                label="Filter list mode"
            >
                <Select placeholder="Select filter list mode">
                    {Object.values(FilterListBean.FilterModeEnum).map(type => <Option key={type} value={type}>{type}</Option>)}
                </Select>
            </FormItem>
            <FormItem
                name="data"
                label="Filter data"
            >
                <TextArea rows={4} />
            </FormItem>
        </Card>
        <div className="create-cancel-group">
            <Button type="primary" htmlType="submit">Save</Button>
            <Button htmlType="button" danger onClick={() => navigateTo('/filter-list')}>Cancel</Button>
        </div>
    </Form>
}

export default FilterListEdit


// WEBPACK FOOTER //
// ./src/component/app/filterList/FilterListEdit.tsx